import { isNullOrUndefined, reduce } from "et3-type-guards";
import i18n from "../../../../constants/i18n";
import { TCorePage, TReport, TReportRKey } from "../../../../Types";
import ET3Div from "../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Text from "../../../../core/et3-text";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";
import Conversation from "./conversation";
import ReportSubjectsDetails from "./report-subjects-details";
import { useRef, useEffect } from "react";
import ET3DivRef from "../../../../core/et3-div-ref";

const DetailsReportBox = withLiteObserverAndTheme<{
  report: TReport;
  status: string;
  pageName: TCorePage;
}>((props) => {
  const { report, status, pageName, theme } = props;
  const { colors } = theme;
  const messagesEndRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!isNullOrUndefined(messagesEndRef.current)) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [report]);

  const reason1 = reduce(() => report.reason1, 0);
  const reason2 = reduce(() => report.reason2, 0);
  const reason3 = reduce(() => report.reason3, 0);
  const reason4 = reduce(() => report.reason4, 0);
  const reason5 = reduce(() => report.reason5, 0);
  const reportReasons: { [key: string]: 1 | 0 } = {
    reason_1: reason1,
    reason_2: reason2,
    reason_3: reason3,
    reason_4: reason4,
    reason_5: reason5
  };
  const keys = Object.keys(reportReasons);
  const { comment, conversation, reporterId } = report;
  const pendingReport = status === "pending";
  const reasonsComponent = keys.map((key) => {
    if (reportReasons[key] === 1) {
      let reportKey: TReportRKey;
      switch (`REPORT_${key.toUpperCase()}`) {
        case "REPORT_REASON_1":
          reportKey = "REPORT_REASON_1";
          break;
        case "REPORT_REASON_2":
          reportKey = "REPORT_REASON_2";
          break;
        case "REPORT_REASON_3":
          reportKey = "REPORT_REASON_3";
          break;
        case "REPORT_REASON_4":
          reportKey = "REPORT_REASON_4";
          break;
        default:
          reportKey = "REPORT_REASON_5";
          break;
      }
      return (
        <Et3Text
          fontFamily={"BOLD"}
          fontSize={18}
          text={i18n.get(reportKey)}
          isSpan={false}
          color={colors.all.black}
          style={{}}
        />
      );
    } else return null;
  });

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      fDirection="column"
      justifyContent="center"
      alignItems="flex-start"
      withShadow={false}
      width={pendingReport ? 1150 : 1480}
      height={0}
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="column"
        justifyContent="space-between"
        alignItems="flex-start"
        withShadow={false}
        width={1200}
        height={100}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <ET3Div
          isScrollable={false}
          isExtendable={false}
          fDirection="row"
          justifyContent="flex-start"
          alignItems="center"
          withShadow={false}
          width={1200}
          height={50}
          color={colors.all.transparent}
          style={{}}
          onClick={() => {}}
        >
          <Et3Text
            fontFamily={"BOLD"}
            fontSize={20}
            text={`${i18n.get("REASON")}`}
            isSpan={false}
            color={colors.all.black}
            style={{}}
          />
          <Et3Margin top={0} right={0} bottom={0} left={10} />
          {reasonsComponent}
        </ET3Div>
        <ET3Div
          isScrollable={false}
          isExtendable={false}
          fDirection="row"
          justifyContent="flex-start"
          alignItems="center"
          withShadow={false}
          width={1000}
          height={50}
          color={colors.all.transparent}
          style={{}}
          onClick={() => {}}
        >
          <Et3Text
            fontFamily={"BOLD"}
            fontSize={20}
            text={`${i18n.get("COMMENT")}`}
            isSpan={false}
            color={colors.all.black}
            style={{}}
          />
          <Et3Margin top={0} right={10} bottom={0} left={0} />
          <Et3Text
            fontFamily={"MEDIUM"}
            fontSize={18}
            text={comment}
            isSpan={false}
            color={colors.all.black}
            style={{ wordWrap: "break-word", fontStyle: "italic" }}
          />
        </ET3Div>
      </ET3Div>

      <ReportSubjectsDetails
        report={report}
        status={status}
        pageName={pageName}
        pendingReport={pendingReport}
      />

      <Et3Margin top={30} bottom={0} left={0} right={0} />

      <ET3DivRef
        isScrollable={false}
        isExtendable={false}
        fDirection="row"
        justifyContent="flex-start"
        alignItems="center"
        withShadow={false}
        width={1200}
        height={0}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
        refDiv={messagesEndRef}
      />
      <Conversation
        messages={conversation}
        senderId={reporterId}
        reporterGender={reduce(() => report.reporterGender, "")}
        reportedGender={reduce(() => report.reportedGender, "")}
      />
    </ET3Div>
  );
});
export default DetailsReportBox;
